import e from "@dialpad/dialtone-tokens/layered/themes/tokens-cedar-grove-colors.css?inline";
//#region themes/cedar-grove.js
var t = {
	brand: {
		css: e,
		name: "cedar-grove"
	},
	material: { name: "iron" }
};
//#endregion
export { t as default };
